import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, Sparkles, Receipt, Users2 } from "lucide-react";

const slides = [
  {
    eyebrow: "Group outings",
    title: "Ten emails turned into ten minutes.",
    body: "Tell us your group size, budget and vibe. Tablo curates 3–5 Hyderabad venues with locked, GST-inclusive package prices.",
    icon: Users2,
    image: "https://images.pexels.com/photos/19447626/pexels-photo-19447626.jpeg",
  },
  {
    eyebrow: "Pre-negotiated",
    title: "Real menu, real Tablo discount.",
    body: "See the restaurant's MRP next to the Tablo price on every package and dish. Always 12–22% off, never opaque.",
    icon: Receipt,
    image: "https://images.pexels.com/photos/16240681/pexels-photo-16240681.jpeg",
  },
  {
    eyebrow: "AI concierge",
    title: "Curate your menu, or pick it yourself.",
    body: "Let Tablo build a balanced set menu within ±5% of your budget — or pick the dishes yourself. We'll tell you which saves more.",
    icon: Sparkles,
    image: "https://images.pexels.com/photos/9409791/pexels-photo-9409791.jpeg",
  },
];

export default function Intro() {
  const [idx, setIdx] = useState(0);
  const nav = useNavigate();
  const slide = slides[idx];
  const Icon = slide.icon;

  const finish = () => {
    localStorage.setItem("tablo_intro_seen", "1");
    nav("/auth");
  };
  const next = () => {
    if (idx < slides.length - 1) setIdx(idx + 1);
    else finish();
  };
  const skip = () => finish();

  return (
    <div className="min-h-screen bg-cream text-ink flex flex-col" data-testid={`intro-slide-${idx}`}>
      <div className="flex items-center justify-between px-5 py-4">
        <Link to="/" className="font-serif text-xl" data-testid="intro-brand-link">Tablo</Link>
        <button onClick={skip} className="text-sm text-light-ink hover:text-ink" data-testid="intro-skip-btn">Skip</button>
      </div>

      <div className="flex-1 flex flex-col md:flex-row md:items-center md:gap-12 px-5 md:px-12 max-w-5xl md:mx-auto w-full">
        <div className="relative w-full md:w-1/2 aspect-[4/5] md:aspect-[3/4] rounded-3xl overflow-hidden shadow-tablo-lg mb-8 md:mb-0 animate-fade-up">
          <img src={slide.image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent" />
          <div className="absolute bottom-5 left-5 right-5">
            <div className="inline-flex items-center gap-2 bg-cream/90 backdrop-blur rounded-full px-3 py-1.5 mb-3">
              <Icon className="w-4 h-4 text-amber" strokeWidth={1.6} />
              <span className="text-xs uppercase tracking-[0.18em] text-ink font-medium">{slide.eyebrow}</span>
            </div>
          </div>
        </div>

        <div className="animate-fade-up md:w-1/2 max-w-md">
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl leading-[1.1]">{slide.title}</h1>
          <p className="text-light-ink text-base md:text-lg mt-3 md:mt-5 leading-relaxed">{slide.body}</p>
        </div>
      </div>

      <div className="px-5 md:px-12 pb-8 pt-6 space-y-4 max-w-5xl md:mx-auto w-full">
        <div className="flex gap-1.5 justify-center">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-ink" : "w-1.5 bg-tablo-border"}`}
              data-testid={`intro-dot-${i}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        <button onClick={next} className="tablo-btn-primary w-full md:w-auto md:px-12 md:mx-auto md:flex inline-flex items-center justify-center gap-2" data-testid="intro-next-btn">
          {idx < slides.length - 1 ? "Next" : "Get started"}
          <ArrowRight className="w-4 h-4" strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
